// extracted by mini-css-extract-plugin
module.exports = {"home":"styles__home__yibil","wrapper":"styles__wrapper__1vJdE","title":"styles__title__4x-5d","highlighted":"styles__highlighted__2VgU3","footer":"styles__footer__2EghH"};